import { render, staticRenderFns } from "./standardedit.vue?vue&type=template&id=a9e3dad4&scoped=true"
import script from "./standardedit.vue?vue&type=script&lang=js"
export * from "./standardedit.vue?vue&type=script&lang=js"
import style0 from "./standardedit.vue?vue&type=style&index=0&id=a9e3dad4&prod&scoped=scoped&lang=css"
import style1 from "./standardedit.vue?vue&type=style&index=1&id=a9e3dad4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e3dad4",
  null
  
)

export default component.exports